import { jwtDecode } from 'jwt-decode'; 
import { cerrarSesion } from './funciones';

export const getRoleFromToken = (token) => {
  try {
    const decodedToken = jwtDecode(token);  
    if(decodedToken.exp * 1000 < Date.now()){
      cerrarSesion(false);      
      return "-1"; 
    }
    return decodedToken.authorities; 
  } catch (error) {
    return null;
  }
};
